import React from 'react';
import {
  Box,
  Card,
  Button,
  TextField,
  MenuItem,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';
import { format } from 'date-fns';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

let d = new Date();
let today = format(d, 'yyyy-MM-dd');

const objectToCsv = function (data) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${val}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class ProdDateChartGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: [],
      page: 0,
      rowsPerPage: -1,
      order: 'asc',
      orderBy: null,
      category: 0,
      delivery: 2,
      dateTo: today,
      categoryName: "All categories",
      sx_hidden: { display: 'none' },
      value: "1",
      categories: [{ 'iref': 0, 'name': "All categories" }],
      location: 0,
      locationName: "All locations",
      locations: [{ 'iref': 0, 'name': "All Locations" }],
      deliverys: [{ 'iref': 2, 'name': "All" }, { 'iref': 0, 'name': "Restaurant" }, { 'iref': 1, 'name': "Delivery" }, { 'iref': 3, 'name': "App Clients" }],
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.selectDateTo = this.selectDateTo.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);

    this.queryData = {};
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      "category": this.state.category,
      "location": this.state.location,
      "dateTo": this.state.dateTo,
      "delivery": this.state.delivery
    };

    let data = BackofficeReportsApi.getSalesCategoryDaily(this.state.client, queryData);

    if (data) {
      this.setState({ saleslocation_list: data });
    }

    this.setState({ filterData: queryData });

    let categories = this.state.client.getData(Config.API_URL_PRODUCT_CATEGORY, queryData);
    this.setState({ categories: categories.productCategories });

    let locations = BackofficeReportsApi.getLocations(this.state.client);
    this.setState({ locations: locations.locations });
  }

  doSync() {
    this.getData();
    this.setState({ page: 0 });
  }

  selectDateTo = (event) => {
    this.setState(
      { dateTo: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  selectLocation = (event) => {
    this.setState(
      {
        location: event.target.value,
        locationName: this.state.locations.find((o) => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  }

  selectCategory = (event) => {
    this.setState(
      {
        category: event.target.value,
        categoryName: this.state.categories.find((o) => o.iref === event.target.value)
      },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      { delivery: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  }

  handleRequestSort = (property) => {
    const isAscending = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({ order: isAscending ? 'desc' : 'asc', orderBy: property, page: 0 });
  }

  onDownload = () => {
    const link = document.createElement("a");
    link.download = "categorySales_" + this.state.locationName.name + this.state.categoryName.name + "_" + this.state.dateTo + ".csv";

    let csvData = objectToCsv(this.state.saleslocation_list.result);
    let csvHeader = "category Sales\nLocation: " + this.state.locationName.name + "\ncategory: " + this.state.categoryName.name + "\nMonth to Date: " + this.state.dateTo + "\nDelivery: " + this.state.delivery;
    let csv = "\uFEFF" + csvHeader + "\n" + csvData;

    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  render() {
    let categories = [{ 'iref': 0, 'name': "All Categories" }];

    if (this.state.categories) {
      Object.keys(this.state.categories).forEach(key => {
        let fData = this.state.categories[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        categories.push(myData);
      });
    }

    let locations = [{ 'iref': 0, 'name': "All Locations" }];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        locations.push(myData);
      });
    }

    let deliverys = [
      { 'iref': 2, 'name': "All" },
      { 'iref': 0, 'name': "Restaurant" },
      { 'iref': 1, 'name': "Delivery" },
      { 'iref': 3, 'name': "App Clients" }
    ];

    let categorySalesData = [];
    let categorySalesList = [];

    if (this.state.saleslocation_list) {
      if (this.state.saleslocation_list.result) {
        let counter = 0;

        Object.keys(this.state.saleslocation_list.result).forEach(key => {
          let fData = this.state.saleslocation_list.result[key];

          let myData = {
            x: fData.date,
            y: parseInt(fData.value)
          };

          let p = {
            id: counter + 1,
            date: fData.date,
            quantity: thousandsSeparator(fData.quantity),
            value: thousandsSeparator(parseInt(fData.value))
          };

          if (counter < 10) {
            categorySalesData.push(myData);
          }

          counter += 1;
          categorySalesList.push(p);
        });
      }
    }

    const { order, orderBy } = this.state;
    const sortedCategorySalesList = orderBy
      ? [...categorySalesList].sort((a, b) => {
          const normalize = (value) => {
            const numericValue = Number(String(value ?? '').replace(/,/g, ''));
            return String(value ?? '').trim() !== '' && Number.isFinite(numericValue)
              ? numericValue
              : String(value ?? '').toLocaleLowerCase();
          };
          const aValue = normalize(a[orderBy]);
          const bValue = normalize(b[orderBy]);
          if (aValue < bValue) return order === 'asc' ? -1 : 1;
          if (aValue > bValue) return order === 'asc' ? 1 : -1;
          return 0;
        })
      : categorySalesList;

    const controlSx = {
      '& .MuiInputBase-root': {
        height: 36,
        borderRadius: '12px',
        fontSize: {
          xs: '0.82rem',
          sm: '0.88rem',
        },
        bgcolor: '#fff',
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.76rem',
          sm: '0.82rem',
        },
      },
      '& .MuiSelect-select': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    };

    const dateControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 130,
      },
    };

    const mediumControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 180,
      },
    };

    const smallControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 110,
      },
    };

    const tableContainerSx = {
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      '&::-webkit-scrollbar': {
        height: 8,
        width: 8,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(15, 23, 42, 0.18)',
        borderRadius: 999,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(15, 23, 42, 0.04)',
      },
    };

    const tableSx = {
      minWidth: '100%',
      width: '100%',
      tableLayout: {
        xs: 'fixed',
        md: 'auto'
      },
      '& .MuiTableCell-root': {
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
        fontSize: {
          xs: '0.8rem',
          sm: '0.88rem',
          md: '0.92rem',
        },
      },
      '& .MuiTableRow-hover:hover': {
        backgroundColor: 'rgba(26, 35, 126, 0.035)',
      },
    };

    const headerCellSx = {
      py: {
        xs: 0.5,
        sm: 0.85,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      bgcolor: '#f8fafc',
      color: '#1a237e',
      fontWeight: 650,
      lineHeight: 1.15,
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip',
    };

    const bodyCellSx = {
      py: {
        xs: 0.55,
        sm: 0.8,
      },
      px: {
        xs: 0.35,
        sm: 1,
      },
      whiteSpace: 'nowrap',
      color: '#111827',
      fontWeight: 450,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontVariantNumeric: 'tabular-nums',
    };

    const paginationSx = {
      flexShrink: 0,
      borderTop: '1px solid rgba(15, 23, 42, 0.06)',
      bgcolor: '#fff',
      minHeight: {
        xs: 44,
        sm: 52,
      },
      '& .MuiTablePagination-toolbar': {
        minHeight: {
          xs: 44,
          sm: 52,
        },
        px: {
          xs: 0.5,
          sm: 1,
        },
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap',
        },
        gap: {
          xs: 0.25,
          sm: 0.5,
        },
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: {
          xs: '0.88rem',
          sm: '0.92rem',
          md: '1rem',
        },
        m: 0,
      },
      '& .MuiTablePagination-actions': {
        ml: {
          xs: 0,
          sm: 1,
        },
      },
    };

    return (
      <Card
        variant="outlined"
        sx={{
          width: '100%',
          height: '100%',
          maxHeight: '100%',
          minHeight: 0,
          borderRadius: {
            xs: 0,
            sm: '14px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 'none',
          border: {
            xs: 'none',
            sm: '1px solid rgba(15, 23, 42, 0.06)',
          },
          bgcolor: '#fff',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.75,
              sm: 1,
            },
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: '#fff',
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexWrap: 'wrap',
              maxHeight: {
                xs: 122,
                sm: 96,
              },
              overflowY: 'auto',
              overflowX: 'hidden',
              pr: 0.25,
              '&::-webkit-scrollbar': {
                width: 8,
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(15, 23, 42, 0.18)',
                borderRadius: 999,
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(15, 23, 42, 0.04)',
              },
            }}
          >
            <TextField
              size="small"
              id="date-to"
              label="Month to"
              type="date"
              value={this.state.dateTo}
              variant="outlined"
              sx={dateControlSx}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: "2023-01-01",
                style: {
                  paddingRight: 5,
                  paddingLeft: 5
                }
              }}
              onChange={this.selectDateTo}
            />

            <TextField
              id="standard-select-location"
              select
              defaultValue="0"
              variant="outlined"
              size="small"
              sx={mediumControlSx}
              onChange={this.selectLocation}
            >
              {locations.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-category"
              select
              defaultValue="0"
              variant="outlined"
              size="small"
              sx={mediumControlSx}
              onChange={this.selectCategory}
            >
              {categories.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-delivery"
              select
              defaultValue="2"
              variant="outlined"
              size="small"
              sx={smallControlSx}
              onChange={this.selectDelivery}
            >
              {deliverys.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <Tooltip title="Download CSV">
              <Button
                size="small"
                onClick={this.onDownload}
                variant="contained"
                sx={{
                  display: {
                    xs: 'none',
                    sm: 'inline-flex',
                  },
                  minWidth: 36,
                  width: 36,
                  height: 36,
                  p: 0,
                  flexShrink: 0,
                  borderRadius: '12px',
                  color: '#1a237e',
                  bgcolor: 'rgba(26, 35, 126, 0.08)',
                  boxShadow: 'none',
                  border: '1px solid rgba(26, 35, 126, 0.12)',
                  '&:hover': {
                    bgcolor: 'rgba(26, 35, 126, 0.12)',
                    boxShadow: 'none',
                  },
                }}
              >
                <FileDownloadIcon fontSize="small" />
              </Button>
            </Tooltip>
          </Box>
        </Box>

        <TableContainer sx={tableContainerSx}>
          <Table stickyHeader aria-label="category sales date table" sx={tableSx}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    ...headerCellSx,
                    width: {
                      xs: '35%',
                      sm: '38%',
                    },
                    textAlign: 'left',
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'date'}
                    direction={orderBy === 'date' ? order : 'asc'}
                    onClick={() => this.handleRequestSort('date')}
                  >
                    Date
                  </TableSortLabel>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    ...headerCellSx,
                    width: {
                      xs: '30%',
                      sm: '27%',
                    },
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'quantity'}
                    direction={orderBy === 'quantity' ? order : 'asc'}
                    onClick={() => this.handleRequestSort('quantity')}
                  >
                    Qty
                  </TableSortLabel>
                </TableCell>

                <TableCell
                  align="right"
                  sx={{
                    ...headerCellSx,
                    width: {
                      xs: '35%',
                      sm: '35%',
                    },
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'value'}
                    direction={orderBy === 'value' ? order : 'asc'}
                    onClick={() => this.handleRequestSort('value')}
                  >
                    Value
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(this.state.rowsPerPage > 0
                ? sortedCategorySalesList.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                : sortedCategorySalesList
              ).map((category) => {
                return (
                  <TableRow hover key={category.id} tabIndex={-1}>
                    <TableCell
                      sx={{
                        ...bodyCellSx,
                        fontWeight: 550,
                        fontVariantNumeric: 'normal',
                      }}
                    >
                      {category.date}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {category.quantity}
                    </TableCell>

                    <TableCell align="right" sx={bodyCellSx}>
                      {category.value}
                    </TableCell>
                  </TableRow>
                );
              })}

              {categorySalesList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <Box
                      sx={{
                        py: 4,
                        color: 'text.secondary',
                        fontSize: {
                          xs: '0.86rem',
                          sm: '0.92rem',
                        },
                      }}
                    >
                      No data
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, { value: -1, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={categorySalesList.length}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={paginationSx}
        />
      </Card>
    );
  }
}

export default ProdDateChartGroup;
